import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/article-card.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts/bebas-neue.ts\",\"import\":\"Bebas_Neue\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"bebasNeue\"}");
